/**
 * @typedef {{
 *   window: Window,
 *   acceptCookiesLevel: number,
 *   dataLayer: null | {push: (args: {event: string}) => void},
 *   userUuid: null | string
 * }} Data
 */

/**
 * @type {Data}
 */
const data = {
  window: window,
  acceptCookiesLevel: 0, // 0 - no button was pressed or check is not finished
  dataLayer: window.dataLayer || null,
  userUuid: null,
};

module.exports = data;
